import { render, staticRenderFns } from "./MaterialStatsCard.vue?vue&type=template&id=1118f4eb&scoped=true&"
import script from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsCard.vue?vue&type=style&index=0&id=1118f4eb&prod&lang=sass&"
import style1 from "./MaterialStatsCard.vue?vue&type=style&index=1&id=1118f4eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1118f4eb",
  null
  
)

export default component.exports